// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2VTuu","obliqueLineWrap":"membershipbadge_obliqueLineWrap__8Y8zF","obliqueLine":"membershipbadge_obliqueLine__1TDKA"};